import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageRoot = lazy(() => import('@app/components/PageRoot'))
const WorkflowsPage = lazy(() => import('.'))

class WebComponent extends ReactWebComponent {
	override render() {
		return (
			<PageRoot>
				<WorkflowsPage />
			</PageRoot>
		)
	}
}

customElements.define('workflows-page', WebComponent)
